// interfaces.
import { RawRuleItem } from "@store/apiSlices/incentiveRules/interfaces/rawRules.interfaces";

// ─── Labels por variante ───────────────────────────────────────────────────────

const VARIANT_CONFIG = {
  winner: {
    rowClass: "rule-row",
    priorityClass: "rule-priority",
    activeLabel: "● Activa",
    inactiveLabel: "○ Inactiva",
  },
  contender: {
    rowClass: "rule-row rule-row--experiment",
    priorityClass: "rule-priority rule-priority--experiment",
    activeLabel: "● Activo",
    inactiveLabel: "○ Inactivo",
  },
  confianza: {
    rowClass: "rule-row rule-row--confianza",
    priorityClass: "rule-priority rule-priority--confianza",
    activeLabel: "● Activa",
    inactiveLabel: "○ Inactiva",
  },
} as const;

// ─── Props ────────────────────────────────────────────────────────────────────

interface Props {
  rule: RawRuleItem;
  variant: "winner" | "contender" | "confianza";
  onEdit: (rule: RawRuleItem) => void;
  onToggle: (rule: RawRuleItem) => void;
}

// ─── Component ────────────────────────────────────────────────────────────────

export const RulePanelRow = ({ rule, variant, onEdit, onToggle }: Props) => {
  const isActive = rule.is_active === "active";
  const { rowClass, priorityClass, activeLabel, inactiveLabel } = VARIANT_CONFIG[variant];

  return (
    <div className={rowClass}>
      <div className={priorityClass}>{rule.rule.priority}</div>

      <div className="rule-info">
        <div className="rule-name">{rule.rule.name}</div>
        {rule.rule.description && (
          <div className="rule-description">{rule.rule.description}</div>
        )}
      </div>

      <div className="rule-actions">
        <span className={`badge-active ${isActive ? "status--active" : "status--inactive"}`}>
          {isActive ? activeLabel : inactiveLabel}
        </span>
        <button
          className="icon-btn icon-btn--primary"
          title="Editar"
          onClick={() => onEdit(rule)}
        >
          ✏️
        </button>
        <button
          className="icon-btn"
          title={isActive ? "Desactivar" : "Activar"}
          onClick={() => onToggle(rule)}
        >
          {isActive ? "⏸" : "▶"}
        </button>
      </div>
    </div>
  );
};
